import React from 'react';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';

const MultipleFacesRejection = ({ onRetry }) => (
  <EmptyState
    headline={COPY.REJECT_MULTIPLE_FACES_HEADLINE}
    subtitle={COPY.REJECT_MULTIPLE_FACES_SUBTITLE}
    ctaLabel={COPY.TRY_AGAIN_CTA}
    onCta={onRetry}
  />
);

export default MultipleFacesRejection;
